import React, { useEffect, useState } from 'react';
import axios from 'axios';
import parse from "html-react-parser";
import { variables } from './Variables.js';
import Most_View_Ar from './Most_View_Ar.js';
export default function PressReleaseAr() {
  const jsonUrl = variables.basename_url + 'updates/index/Coinsinsight_HomeAr_Press.json';
  const [isLoading, setNisLoading] = useState(false);
  async function refda() {
    setNisLoading(true);
    //  To Show or Hidden Header And Footer
    document.getElementById('Arabic_Header').hidden = false;
    document.getElementById('Arabic_Footer').hidden = false;
    fetch(variables.API_URL + '/external_site/meta_Domain?Domain=' + variables.domain + '&FullDomain=' + variables.basename_url, {
      method: 'GET',
      headers: { 'content-type': 'application/json' },
    }).then((res) => {
      return res.json();
    }).then((resp) => {
      console.log(resp);
    }).catch((err) => {
      // alert('  Failed  ');
    });
    Get_Data();
  }
  const [JsonArray, setJsonArray] = React.useState([]);
  const [JsonArray2, setJsonArray2] = React.useState([]);
  async function Get_Data() {
    setNisLoading(true);
    axios.get(jsonUrl)
      .then(function (response) {
        setNisLoading(false);
        console.log(response.data);
        for (let i = 1; i <= response.data.length && i <= response.data.length; i++) {
          let j = i++;
          // Ensure j does not exceed the length of response.data
          if (j <= response.data.length) {
            // Perform your operations here
            JsonArray.push({
              news_title: response.data[i - 1].news_title,
              news_date: response.data[i - 1].news_date.split('T')[0],
              news_imagename: response.data[i - 1].image,
              Description: response.data[i - 1].Description.replace("https://menafn.com/", variables.domain_name + "/")
                .replace("https://menafn.com", variables.domain_name)
                .replace("MENAFN", variables.domain)
                .replace("<table>", "")
                .replace("MENAFN", variables.domain),
              Category: response.data[i - 1].Category,
            });
            JsonArray2.push({
              news_title: response.data[j - 1].news_title,
              news_date: response.data[j - 1].news_date.split('T')[0],
              news_imagename: response.data[j - 1].image,
              link: response.data[j - 1].link,
              Description: response.data[j - 1].Description.replace("https://menafn.com/", variables.domain_name + "/")
                .replace("https://menafn.com", variables.domain_name)
                .replace("MENAFN", variables.domain)
                .replace("<table>", "")
                .replace("MENAFN", variables.domain),
              Category: response.data[j - 1].Category,
            });
          }
        }
      })
  }
  useEffect(() => {
    setNisLoading(true);
    refda();
  }, [])
  return (
    <>


      <section className="all-post-style-2-area mt-3">
        <div className="container custom-container">
          <div className="row justify-content-center">
            <div className="col-lg-8">
              <div className="post-entertainment">
                <div className="section-title">
                  <h3 className="title float-right">     البيان الصحفي</h3>
                  <br></br>
                </div>
                <div className="row">
                  <div className="col-lg-6 col-md-6 p-3">
                    {JsonArray.map(da =>
                      <div key={da.news_title}  >
                        <div className="trending-news-item mb-30">
                          <div className="trending-news-thumb">
                            <a href={da.link}>
                              <img className='rounded' style={{ minWidth: '350px', maxWidth: '350px', maxHeight: '250px', minHeight: '250px' }} src={da.news_imagename} alt="trending" />
                            </a>
                            <div className="circle-bar">
                              <div className="first circle"><canvas width={40} height={40} />
                              </div>
                            </div>
                          </div>
                          <div className="trending-news-content ">
                            <div className="post-meta float-right" >
                              <div className="meta-date ">
                                <span>{da.news_date}</span>
                              </div>
                              <div className="meta-categories ">
                                <a tabIndex={-1}>{da.Category}</a>
                              </div>

                            </div>
                            <br></br> <br></br>
                            <h3 className="title Arabic-text"><a href={da.link} tabIndex={-1}>{da.news_title}</a></h3>
                            <p className="text Arabic-text">{parse(da.Description)}</p>
                          </div>
                        </div>
                      </div>
                    )}
                  </div>
                  <div className="col-lg-6 col-md-6 p-3">
                    {JsonArray2.map(da =>
                      <div key={da.news_title}  >
                        <div className="trending-news-item mb-30">
                          <div className="trending-news-thumb">
                            <a href={da.link}>
                              <img className='rounded' style={{ minWidth: '350px', maxWidth: '350px', maxHeight: '250px', minHeight: '250px' }} src={da.news_imagename} alt="trending" />
                            </a>
                            <div className="circle-bar">
                              <div className="first circle"><canvas width={40} height={40} />
                              </div>
                            </div>
                          </div>
                          <div className="trending-news-content ">
                            <div className="post-meta float-right" >
                              <div className="meta-date ">
                                <span>{da.news_date}</span>
                              </div>
                              <div className="meta-categories ">
                                <a tabIndex={-1}>{da.Category}</a>
                              </div>

                            </div>
                            <br></br> <br></br>
                            <h3 className="title Arabic-text"><a href={da.link} tabIndex={-1}>{da.news_title}</a></h3>
                            <p className="text Arabic-text">{parse(da.Description)}</p>
                          </div>
                        </div>
                      </div>
                    )}
                  </div>
                </div>
              </div>
              <div className="post-add mt-30">
                <a href="#"><img src="./images/ad/ad-1.png" alt="ad" /></a>
              </div>
            </div>
            <div className="col-lg-4">
              <div className="all-post-sidebar">
                <div className="most-share-post">
                  <div className="section-title">
                    <h3 className="title float-right"> الأكثر مشاهده  </h3>
                    <br></br>
                  </div>
                </div>
                <Most_View_Ar />
              </div>
            </div>
          </div>
        </div>
      </section>
    </>
  );
}


